import React from "react";
import LegendItem from "./LegendItem";
import "./Legend.css";

//availableFilters
export default function Legend(props) {
  return (
    <div className="legend-container">
      {props.availableFilters
        ? props.availableFilters.map((filter) => {
          return (
            <LegendItem
              key={filter}
              availableFilters={props.availableFilters}
              hotspotColors={props.hotspotColors}
              type={filter}
            />
          );
        })
        : null}
    </div>
  );
}
